export default __webpack_public_path__ + "188e48b4732c19095089e9ddfabb0912.png";